var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 72,
    viewBox: "0 0 99 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.751 51.9554H16.1832L9.75839 26.8081C9.45344 25.6513 8.80594 24.6286 7.8535 24.1467C5.47656 22.9354 2.85734 21.9714 0 21.4852V20.5171H13.8021C15.707 20.5171 17.1357 21.9714 17.3738 23.6605L20.7073 41.8001L29.271 20.5171H37.6007L24.751 51.9554ZM42.363 51.9554H34.2713L40.9343 20.5171H49.0259L42.363 51.9554ZM59.4944 29.2264C59.7325 27.5332 61.1612 26.565 62.828 26.565C65.4472 26.3219 68.3004 26.8081 70.6815 28.0152L72.1102 21.2463C69.729 20.2782 67.1098 19.792 64.7329 19.792C56.8794 19.792 51.1647 24.1467 51.1647 30.1904C51.1647 34.7882 55.2126 37.2023 58.0699 38.6567C61.1612 40.1069 62.3518 41.075 62.1137 42.5252C62.1137 44.7004 59.7325 45.6686 57.3556 45.6686C54.4983 45.6686 51.6409 44.9435 49.0259 43.7323L47.5972 50.5053C50.4546 51.7124 53.5458 52.1986 56.4032 52.1986C65.2091 52.4375 70.6815 48.087 70.6815 41.557C70.6815 33.3338 59.4944 32.8519 59.4944 29.2264ZM99 51.9554L92.5752 20.5171H85.6741C84.2455 20.5171 82.8168 21.4852 82.3406 22.9354L70.4434 51.9554H78.7731L80.4357 47.3619H90.6703L91.6227 51.9554H99ZM86.8647 28.9834L89.2416 40.832H82.5787L86.8647 28.9834Z",
    fill: "#182E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.8a5f27f0a48e4ef7b136bcf54d823847.svg";
export { ForwardRef as ReactComponent };